import { v4 as uuidv4 } from 'uuid';

const idPrefix = 'LOCAL-'

export default () => {
    return idPrefix + uuidv4()    
}